import logo from '../assets/sproutLogo.svg'
import { Link } from "react-router-dom";


const Footer = () => {
    return (
        <div className="wrapper">
        <footer className="footer">
            
            <div className="logo">
                <Link 
                to="/"><img src={logo} alt="Sprout logo" /></Link>
                
                
                
                <h5>Sprout</h5>
            </div>
            <p>Copyright Sprout 2022</p>
        </footer>
        </div>
    )
}

export default Footer